import { useQuery } from '@apollo/client';
import { MY_VACATION_HISTORY } from '../userTypeDefs';

export const useQueryVacationHistory = (options?: any): any =>
  useQuery(MY_VACATION_HISTORY, options);


